import React, { Component } from "react";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { CardValue, CurrencyValue } from "components/support";

import "./summary-card.css";

class SummaryCard extends Component {
  render() {
    const { label, value } = this.props;

    return (
      <Paper elevation={1} className="summary-card text-center">
        <Typography type="headline">{label}</Typography>
        <CardValue fit positive={value > 0}>
          <CurrencyValue value={value * 100} type="money" />
        </CardValue>
      </Paper>
    );
  }
}

export default SummaryCard;



// WEBPACK FOOTER //
// ./src/components/app/management/devolution-report/summary-card/index.jsx